/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeamSettingsAdminTeamCalendar_team = {
    readonly id: string;
    readonly teamId: string;
    readonly teamName: string;
    readonly teamCalendarId: string | null;
    readonly " $refType": "TeamSettingsAdminTeamCalendar_team";
};
export type TeamSettingsAdminTeamCalendar_team$data = TeamSettingsAdminTeamCalendar_team;
export type TeamSettingsAdminTeamCalendar_team$key = {
    readonly " $data"?: TeamSettingsAdminTeamCalendar_team$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeamSettingsAdminTeamCalendar_team">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamSettingsAdminTeamCalendar_team",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "teamId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "teamName",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "teamCalendarId",
            "storageKey": null
        }
    ],
    "type": "Team",
    "abstractKey": null
} as any;
(node as any).hash = 'ae71bfeed2281ddaa4dd94ef0d43a844';
export default node;
